import { render, staticRenderFns } from "./help-menu.vue?vue&type=template&id=18881e05"
import script from "./help-menu.vue?vue&type=script&lang=js"
export * from "./help-menu.vue?vue&type=script&lang=js"
import style0 from "./help-menu.vue?vue&type=style&index=0&id=18881e05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports